import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'authMod'
    ])
  },
  methods: {
    $can(permissionName) {
      let Permission = this.authMod.user.user.permission
      if (typeof Permission != 'undefined') {
        return Permission.indexOf(permissionName) !== -1;
      }
    },
    $role(roleName) {
    	let Role = this.authMod.user.user.role
    	if (typeof Role != 'undefined') {
    		return Role.indexOf(roleName) !== -1;
    	}
    }
  },
};